<div id="position-vehicle" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Localisation du véhicule
                </h2>
                <div uk-grid class="remove-grid-ml-pl uk-grid-small">
                    <div class="uk-width-12-12">
                        <div style="width:100%; height: 450px;" id="reposition"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">
                    Fermer
                </button>
            </p>
        </div>
    </div>
</div>